import React, { Suspense, useEffect, useState } from 'react'
import classes from "./LogsTableLayout.module.css";
import Card from "./Card";
import Table from './Table/Table';
import tableClasses from './Table/EventsTable.module.css';
import { Await, Link, useLoaderData, useNavigate } from 'react-router-dom';
import { Oval, Bars } from 'react-loading-icons';
import Modal from '../Modal/Modal';
import alarm from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/__Alarm - Off.svg"
import cameraOn from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/__Camera - On.svg"
import cameraOff from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/__Camera - Off.svg"
import gateOpen from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/__Gate - Closed.svg"
import gateClosed from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/__Gate - Open.svg"
import doorOpen from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/__Door - Open Black.svg"
import doorClosed from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/__Door - Closed Black.svg"
import defaultOn from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/__Sensor - On.svg"
import defaultOff from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/__Sensor - Off.svg"
import armed from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/armed.png"
import disarmed from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/disarmed.png"
import pulsed from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/pulsed.png"
import locked from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/locked.png"
import unlocked from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/unlocked.png"
import otp from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/OTP.png"
import input_on from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/input_on.png"
import input_off from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/input_off.png"
import update from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/update.png"
import add from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/add.png"
import added from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/added.png"
import used_otp from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/used_otp.png"
import unlocked_unopened from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/unlocked_unopened.png"
import delete_pin from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/delete_pin.png"
import deleted from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/deleted.png"
import incorrect_pin from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/incorrect_pin.png"
import linked from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/linked.png"
import unlinked from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/unlink.png"
import invited from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/invited.png"
import offline from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/offline.png"
import online from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/online.png"
import not_received from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/schedule_failed.png"
import accepted from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/accepted.png"
import left from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/left.png"
import camect from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/camect.png"
import copy_users from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/copyUsers.png"
import override from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/override.png"
import warning from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/warning.png"
import changeRole from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/swap.png"
import gateway from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/gateway.png"
import expired from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/time.png"
import EventsTable from './Table/EventsTable';
import Export from '../UI/Cards/Logs Cards/Export/Export';
import BasicTable from './Table/Table';
import Button1 from '../UI/Button/Button1';
import SearchbarSmall from '../UI/Inputs/SearchbarSmall';
import { useDispatch, useSelector } from 'react-redux';
import ExportExcel from '../ExcelExport/ExcelExport';
import LinegraphPeaked from '../UI/Graphs/linegraphPeaked';
import { da } from 'date-fns/locale';
import { sub } from 'date-fns';
import DataManager from '../../hooks/DataManager';
import { authActions } from '../../store/auth-Slice';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const LogsTableLayout = ({ data, isloading, Filtering, setExportData: setExportDataProp }) => {
  console.log(data);

  const dataManager = new DataManager();
  const dispatch = useDispatch();

  const [snapshotURL, setSnapshotURL] = useState("")
  const [showSnapshot, setShowSnapshot] = useState(false)
  
  var m_names = window.innerWidth <= 1280
  ? ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"] // Abbreviated for smaller screens
  : ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]; // Full names for larger screens

  const BLOCKED_USERS = [18965, 4133, 17103, 2582, 4121, 11, 12]

  function formatDate(date) {

      var sup = "";
  
      if (date.getDate() == 1 || date.getDate() == 21 || date.getDate() ==31)
      {
          sup = "st";
      }
      else if (date.getDate() == 2 || date.getDate() == 22)
      {
           sup = "nd";
      }
      else if (date.getDate() == 3 || date.getDate() == 23)
      {
          sup = "rd";
      }
      else
      {
          sup = "th";
      }
  
      var curr_month = date.getMonth();
      var curr_year = date.getFullYear();

      var hours = date.getHours();
      var minutes = date.getMinutes();
      
      var ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0'+minutes : minutes;
       var strTime = hours + ':' + minutes + ' ' + ampm;
  
      return (date.getDate() + sup + " " + m_names[curr_month] + " " + curr_year + ", " + strTime);
  }

  const iconMapping = [
    armed,
    disarmed,
    pulsed,
    locked,
    unlocked,
    otp,
    input_off,
    input_on,
    update, 
    add, 
    added, 
    used_otp, 
    unlocked_unopened, 
    delete_pin, 
    deleted, 
    incorrect_pin, 
    linked, 
    unlinked, 
    invited, 
    offline, 
    online, 
    not_received, 
    accepted, 
    left, 
    camect, 
    copy_users, 
    override, 
    warning, 
    changeRole, 
    gateway,
    expired
  ]

  let tableData = data;

  const [pageSize, setPageSize] = useState(10)

  const getActivityText = (event) => {
    const { subType, eventData, type } = event;
    let recipientName = event.recipientName;
    if (recipientName == "Unknown") recipientName = "";
    console.log(event);
    switch (subType) {
      case 'removed':           return recipientName + " " + subType;
      case 'added':             return recipientName + " " + subType;
      case 'changeRole':        return recipientName + "'s " + eventData;
      case 'suspended':         return recipientName + " was " + eventData;
      case 'unsuspended':       return recipientName + " was " + eventData;
      case "OPEN_CLOSE_LOCKED": return eventData + " relocked";
      case "OTP_UNLOCK":        return eventData + " unlocked with OTP";
      case "PIN_UNLOCK":        return eventData;
      case "MASTER_PIN_UNLOCK": return eventData + " unlocked with master PIN";
      case "UNOPENED_LOCKED":   return eventData + " unlocked but not opened";
      case "INCORRECT_PIN":     return "Incorrect PIN was attempted on " + eventData;
      case "Unlock":            return eventData + " unlocked";
      case "DELETE_PIN":        return "Pincode deleted from " + eventData;
      case "FIRST_DURATION_UNLOCK": return "Unlocked using Duration PIN";
      case "BLE_PIN_CREATED":   return "BLE Pin created for " + eventData;
      case "expired":           return recipientName + " - site access expired";
      default:                  return eventData;
    }
  };

  const HandleViewSnapshot = (URL) => {
    console.log(URL);
    setSnapshotURL(URL)
    setShowSnapshot(true);
  } 

  const tablecolumns = [
    {
      id: 'activity',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Activity</h3>
        </div>
      ),
      accessorKey: 'eventData',
      cell: (row) => {
        const subType = row.row.original.subType;
        const eventData = row.row.original.eventData;
        let recipientName = row.row.original.recipientName;
        if (recipientName == "Unknown"){
          recipientName = ""
        }
        const type = row.row.original.type

        const rowText = getActivityText(row.row.original);
        let iconPath;
        let snapshotURL = row.row.original.snapshotURL
        console.log(snapshotURL);

        if (type === "Lock" || type === "IglooEvent"){
          if (subType === "Unlock"){
            iconPath = iconMapping[4]
          } else if (subType === "OPEN_CLOSE_LOCKED") {
            iconPath = iconMapping[3]
          } else if (subType === "OTP" || subType === "BLE_PIN_CREATED"){
            iconPath = iconMapping[5]
          } else if (subType === "OTP_UNLOCK" || subType === "PIN_UNLOCK" || subType === "FIRST_DURATION_UNLOCK" || subType === "FIRST_PERMANENT_UNLOCK"){
            iconPath = iconMapping[11]
          } else if (subType === "UNOPENED_LOCKED"){
            iconPath = iconMapping[12]
          } else if (subType === "DELETE_PIN"){
            iconPath = iconMapping[13]
          } else if (subType === "INCORRECT_PIN"){
            iconPath = iconMapping[15]
          } else if (subType === "LINK"){
            iconPath = iconMapping[16]
          } else if (subType === "UNLINK"){
            iconPath = iconMapping[17]
          }
        } else if (type === "Input") {
          if (subType === "Armed"){
            iconPath = iconMapping[7]
          } else {
            iconPath = iconMapping[6]
          }
        } else if (type === "output" || type == "rule") {
          if (subType === "Armed"){
            iconPath = iconMapping[0]
          } else if (subType === "Disarmed"){
            iconPath = iconMapping[1]
          } else {
            iconPath = iconMapping[2]
          }
        } else if (type === "EfentoStatus"){
          iconPath = iconMapping[27]
        } else if (subType === "update" || subType === "Link" || subType === "Update"){
          iconPath = iconMapping[8]
        } else if (subType === "add" || subType === "Set" || subType === "Add" || subType === "Added" || subType === "Linked"){
          iconPath = iconMapping[9]
        } else if (subType === "added" ){
          iconPath = iconMapping[10]
        } else if (subType === "delete" || subType === "removed" || subType === "Delete"){
          iconPath = iconMapping[14]
        } else if (subType === "LINK"){
          iconPath = iconMapping[16]
        } else if (subType === "invited"){
          iconPath = iconMapping[18]
        } else if (subType === "offline"){
          iconPath = iconMapping[19]
        } else if (subType === "online"){
          iconPath = iconMapping[20]
        } else if (type === "ScheduledAction"){
          iconPath = iconMapping[21]
        } else if (subType === "accepted"){
          iconPath = iconMapping[22]
        } else if (subType === "left"){
          iconPath = iconMapping[23]
        } else if (type === "Camect"){
          iconPath = iconMapping[24]
        } else if (subType === "copyDeviceUsers"){
          iconPath = iconMapping[25]
        } else if (subType === "Override"){
          iconPath = iconMapping[26]
        } else if (eventData === "Logs cleared"){
          iconPath = iconMapping[14]
        } else if (subType === "Unlinked"){
          iconPath = iconMapping[14]
        } else if (subType === "changeRole"){
          iconPath = iconMapping[28]
        } else if (subType == "suspended" || subType == "unsuspended"){
          iconPath = iconMapping[27]
        } else if (type == "gateway"){
          if (subType == "tamper"){
            iconPath = iconMapping[27]
          } else {
            iconPath = iconMapping[29]
          }

        } else if (type == "SiteAccess" || type == "userManagement"){
          iconPath = iconMapping[30]
        }

        return (
            <div className={type === "gateway" ? classes.bleCell : undefined} style={{ display: "flex",  alignItems: "center", gap: "10px" }}>
              <div />
              <img className={classes.img} src={iconPath}/>
              {console.log(snapshotURL)}
                {snapshotURL == null ?
                  (<div className={classes.tableValueText}>
                    {`${rowText} `}
                    </div>
                  ) : (
                    <div>
                        <span>
                            {rowText}
                          </span>
                          <span className={classes.linkText} onClick={() => HandleViewSnapshot(snapshotURL)}>
                              {" "}(view snapshot)
                          </span>
                    </div>
                  )
                }



            </div> 
        )
      }
    },
    {
      id: 'time',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Time</h3>
        </div>
      ),
      accessorKey: 'eventDate',
      cell: (row) => {
        const eventDate = new Date(row.row.original.eventDate)
        return (
          <div className={classes.tableValueText}>
            {formatDate(eventDate)}
          </div>)
      }
    },
    {
      id: 'user',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Action completed by</h3>
        </div>
      ),
      accessorKey: 'user',
      cell: (row) => {
        const userID = row.row.original.userID
        const fullName = row.row.original.user
        console.log(userID);
        return (
          <div className={classes.tableValueText}>

            { (userID != null && !BLOCKED_USERS.includes(userID)) ? 
              <Link
                      onClick={() => {
                        dataManager.setItem('clickedUserID', userID);
                        localStorage.setItem('clickedUserID', userID)
                        localStorage.setItem('ClickedUserFullName', fullName);
                        dispatch(authActions.setClickedUserDetails({ userID, fullName }))
                        //dataManager.setItem('clickedUserObj', rowData);
                      }}
                      to={`/Dashboard/Users/UserSites/`}
                  > {row.row.original.user + ` ${row.row.original.type == "rule" ? " via Super rule" : ""}`}
              </Link> 
                : row.row.original.user 
              }
          </div>
        )
      }
    }
  ];

  const [exportData, setExportData] = useState()
  const handleSetExportData = (data) => {
    setExportData(data);
    if (setExportDataProp) setExportDataProp(data);
  }

  const exportFormatFunction = (event) => {
    return {
      Date: formatDate(new Date(event.eventDate)),
      Activity: getActivityText(event),
      User: event.user + (event.type == "rule" ? " via Super rule" : "")
    };
  };

  return (
  <>
      <Dialog 
        header="Snapshot"
        visible={showSnapshot} 
        
        onHide={() => { if (!showSnapshot) return; setShowSnapshot(false); }}>
        <div className="flex flex-col items-center justify-center">

          <img src={snapshotURL} className={classes.snapshotImg}/>
        </div>
      </Dialog>

    <div className={classes.table}>
      <div className={classes["tableCardLayoutUI-wrapper"]}>
        <div className={classes["top-wrapper"]}>
          {/* <div className={classes["info-bar"]}>
            <>
               {isloading && <ThreeDots stroke="var(--Primary-Color)" height={50} width={25} speed={1.5} />}
            </>
           </div>  */}
        </div>
        {isloading ? (
            <div className={classes["skeleton-list"]}>
              {[...Array(10)].map((_, i) => (
                <div key={i} className={classes["skeleton-row"]}>
                  <div className={classes["skeleton-activity"]}>
                    <div className={classes["skeleton-circle"]} />
                    <div className={classes["skeleton-bar"]} style={{ height: "16px", width: `${120 + (i % 4) * 40}px` }} />
                  </div>
                  <div className={classes["skeleton-time"]}>
                    <div className={classes["skeleton-bar"]} style={{ height: "16px", width: "140px" }} />
                  </div>
                  <div className={classes["skeleton-user"]}>
                    <div className={classes["skeleton-bar"]} style={{ height: "16px", width: `${80 + (i % 3) * 30}px` }} />
                  </div>
                </div>
              ))}
            </div>
          ) : (
          <BasicTable data={tableData} columns={tablecolumns} filtering={Filtering} rowClick={false} ShowPagination={true} PageSize={pageSize} setPageSize={setPageSize} paginationOptions={[10, 50, 100]} tableClasses={tableClasses} setExportData={handleSetExportData} exportFormatFunction={exportFormatFunction} />
          )}
      </div>
    </div>
  </>
  )
}

export default LogsTableLayout;